import { all, call } from 'typed-redux-saga/macro';
import { authSaga } from './auth/auth.saga';
import { deviceSaga } from './device/device.saga';
import { devicesetSaga } from './deviceset/deviceset.saga';

export function* rootSaga() {
    yield* all(
        [
            call(authSaga),
            call(devicesetSaga),
            call(deviceSaga),
        ]
    );
}
